import { Block } from '@helvetia/components/Block'
import { Box } from '@helvetia/components/Box'
import { Button } from '@helvetia/components/Button'
import { Col, Row } from '@helvetia/components/layout'
import LinkText from '@helvetia/components/LinkText'
import { MatchMedia } from '@helvetia/components/MatchMedia'
import Spinner from '@helvetia/components/Spinner'
import Text from '@helvetia/components/Text'
import { breakpoints } from '@helvetia/components/theme/breakpoints'
import dayjs from 'dayjs'
import numeral from 'numeral'
import * as React from 'react'
import { WithNamespaces, withNamespaces } from 'react-i18next'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { CustomerLead } from '../../core/domain/customerLead.model'
import { PriceDTO } from '../../core/domain/offerDocument.dto'
import { OfferDocument } from '../../core/domain/offerDocument.model'
import AgentService from '../../core/services/agent.service'
import {
  clearOfferDocumentId,
  clearToken,
} from '../../core/services/storage.service'
import { TitleWrapper } from '../_components/common.styles'
import { LifecycleView } from '../_components/ConnectComponent'
import ContactBox from '../_components/HelvetiaContactBox'
import {
  ClickableIcon,
  DeductibleIcon,
  LiabilityIcon,
  LocationScopeIcon,
  SumInsuredIcon,
  TypeGoodsIcon,
  UserIcon,
  VehiclesIcon,
} from '../_components/icons/icons'
import PdfSVG from '../_components/icons/pdf.svg'
import { Modal } from '../_components/Modal'
import PriceBoxItem from '../_components/summary/PriceBoxItem'
import { PageWrapper } from '../_components/summary/Summary.styles'
import SummaryItem from '../_components/summary/SummaryItem'
import { goToHelvetiaLandingPage } from '../_utils/links'
import { summaryViewMapper } from './Summary.mapper'
import { OfferSummaryData } from './Summary.model'
import { SummaryPresenter } from './Summary.presenter'

export interface View extends LifecycleView {
  showLoading: () => void
  hideLoading: () => void
}

interface Props {
  presenter: SummaryPresenter
}

interface State {
  offer: OfferSummaryData
  customer: CustomerLead
  document: OfferDocument
  obtainedPrice: PriceDTO
  isLoading: boolean
  isModalOpen: boolean
  hasError: boolean
}

export class SummaryRaw
  extends React.Component<Props & RouteComponentProps & WithNamespaces, State>
  implements View {
  private presenter: SummaryPresenter
  private transportingText: string = undefined

  constructor(props) {
    super(props)

    this.presenter = props.presenter
    this.presenter.initialize(this)

    this.state = {
      offer: null,
      customer: null,
      document: null,
      obtainedPrice: null,
      isLoading: false,
      isModalOpen: false,
      hasError: false,
    }
  }

  setInitialValues = (offer, customer, document, obtainedPrice) => {
    this.setState({
      offer: summaryViewMapper(offer),
      customer,
      document,
      obtainedPrice,
    })
  }
  showLoading = () => this.setState({ isLoading: true })

  hideLoading = () => this.setState({ isLoading: false })

  showErrorModal = () => this.setState({ hasError: true })

  hideErrorModal = () => this.setState({ hasError: false })

  showModal = () => this.setState({ isModalOpen: true })

  hideModal = () => this.setState({ isModalOpen: false })

  handleEditing = (page: string) => {
    this.presenter.moveTo(page)
  }

  checkTransportingMessage = () => {
    let prevRemoval: boolean = false
    this.transportingText = ''
    if (this.state.offer.transRemoval > 0) {
      this.transportingText = this.props.t('summary.transRemoval', {
        value: this.state.offer.transRemoval,
      })
      prevRemoval = true
    }

    if (this.state.offer.transTheft > 0) {
      this.transportingText += prevRemoval ? this.props.t('summary.and') : ''
      this.transportingText += this.props.t('summary.transTheft', {
        value: this.state.offer.transTheft,
      })
    }
  }

  render() {
    const { t } = this.props
    const {
      offer,
      customer,
      document,
      obtainedPrice,
      isModalOpen,
      hasError,
    } = this.state

    if (!offer) return <Spinner size="xl" />

    this.checkTransportingMessage()

    let downloadButtonStyles = {
      display: 'flex',
      alignContent: 'baseline',
      justifyContent: 'center',
    }

    if (window.matchMedia(`(min-width: ${breakpoints.tablet}px)`).matches) {
      delete downloadButtonStyles.justifyContent
    }

    if (hasError)
      return (
        <Modal
          buttonText={ t('buttons.accept') }
          onClose={ () => {
            this.hideErrorModal()
            this.props.history.push('/calculator/vehicles')
          } }
          title={
            <>
              <MatchMedia onlyMobile>
                <Text size="sBold">{ t('error.422.error') }</Text>
              </MatchMedia>
              <MatchMedia tablet>
                <Text size="sBold">{ t('error.422.error') }</Text>
              </MatchMedia>
            </>
          }
        >
          <Text size="m" as="div" color="black">
            { t('error.422.sorry') }
          </Text>
          <Text size="m" as="p" color="black">
            { t('error.422.tryAgain') }
          </Text>
        </Modal>
      )

    if (isModalOpen)
      return (
        <Modal
          buttonText={ t('buttons.accept') }
          onClose={ this.presenter.onHideModalHandler }
          title={
            <>
              <MatchMedia onlyMobile>
                <Text size="sBold">{ t('modal.save.title') }</Text>
              </MatchMedia>
              <MatchMedia tablet>
                <Text size="sBold">{ t('modal.save.title') }</Text>
              </MatchMedia>
            </>
          }
        >
          <Text size="s" as="p" color="black">
            { t('modal.save.p1') }
          </Text>
          <Text size="s" as="p" color="black">
            { t('modal.save.p2') }
          </Text>

          <Text size="s" as="p" color="black">
            { t('modal.save.p3') }
            <Text as="span" size="xsBold" color="black">
              { dayjs(document.pricingDate)
                .add(3, 'month')
                .format('DD.MM.YYYY') }
            </Text>
          </Text>

          <Text size="s" as="p" color="black">
            { t('contactMe.questions') }
            <Text size="xsBold" as="span" color="black">
              { ` marine@helvetia.ch` }
            </Text>
          </Text>
        </Modal>
      )

    if (document.contractingDate)
      return (
        <Modal
          buttonText={ t('buttons.accept') }
          onClose={ () => {
            clearOfferDocumentId()
            clearToken()
            this.showLoading()
            goToHelvetiaLandingPage()
          } }
          title={
            <>
              <MatchMedia onlyMobile>
                <Text size="sBold">{ t('modal.alreadyContract.title') }</Text>
              </MatchMedia>
              <MatchMedia tablet>
                <Text size="sBold">{ t('modal.alreadyContract.title') }</Text>
              </MatchMedia>
            </>
          }
        >
          <Text size="s" as="p" color="black">
            { t('modal.alreadyContract.p1') }
          </Text>
          <Text size="s" as="p" color="black">
            { t('modal.alreadyContract.p2') }
          </Text>
          <Text size="s" as="p" color="black">
            { t('modal.alreadyContract.p3') }
          </Text>
        </Modal>
      )
    return (
      <PageWrapper>
        <Row>
          <TitleWrapper mobile={ 12 } tablet={ 12 } desktop={ 12 }>
            <Text as="p" color="black" size="l">
              { t('summary.title') }
            </Text>
          </TitleWrapper>
        </Row>

        <Row verticalGutter marginBottom="s" marginTop="xxs">
          <Col mobile={ 12 } tablet={ 6 } desktop={ 6 } verticalGutter>
            { offer.vehicles > 0 && (
              <SummaryItem
                bottom="xxxs"
                icon={ <VehiclesIcon /> }
                onEditClick={ () => this.handleEditing('/calculator/vehicles') }
              >
                { t('summary.vehicles', {
                  value: `${offer.vehicles}`,
                }) }
              </SummaryItem>
            ) }

            { [...Array(5)].map((x, i) => (
              <>
                { offer[`insuredVehicle${i + 1}`] > 0 && (
                  <SummaryItem
                    key={ i }
                    top="xxxs"
                    bottom="xxxs"
                    icon={ <SumInsuredIcon /> }
                    onEditClick={ () =>
                      this.handleEditing('/calculator/deductible')
                    }
                  >
                    { t('summary.vehiclesInsured', {
                      value: numeral(offer[`insuredVehicle${i + 1}`]).format(
                        '$ 0,0.00',
                      ),
                      index: `${offer[`plate${i + 1}`]}`,
                    }) }
                  </SummaryItem>
                ) }
              </>
            )) }

            { offer.deductible > 0 && (
              <SummaryItem
                top="xxxs"
                bottom="xxxs"
                icon={ <DeductibleIcon /> }
                onEditClick={ () => this.handleEditing('/calculator/deductible') }
              >
                { t('summary.deductible', {
                  value: numeral(offer.deductible).format('$ 0,0.00'),
                }) }
              </SummaryItem>
            ) }

            <SummaryItem
              top="xxxs"
              bottom="xxxs"
              icon={ <LocationScopeIcon /> }
              onEditClick={ () =>
                this.handleEditing('/calculator/location-scope')
              }
            >
              { offer.transEurope > 0
                ? t('summary.transEurope')
                : t('summary.transCH') }
            </SummaryItem>

            { this.transportingText && (
              <SummaryItem
                top="xxxs"
                bottom="xxxs"
                icon={ <TypeGoodsIcon /> }
                onEditClick={ () =>
                  this.handleEditing('/calculator/transporting-goods')
                }
              >
                { this.transportingText }
              </SummaryItem>
            ) }
            <SummaryItem
              top="xxxs"
              bottom="xxxs"
              icon={ <LiabilityIcon /> }
              onEditClick={ () =>
                this.handleEditing('/calculator/transporting-goods')
              }
            >
              { t('summary.liability', {
                value: t(`step4.liability.${offer.liability}`),
              }) }
            </SummaryItem>
            <SummaryItem
              top="xxxs"
              bottom="xxxs"
              icon={ <UserIcon /> }
              onEditClick={ () => this.handleEditing('/calculator/contact-data') }
            >
              { AgentService.isAgentOrBroker() && (
                <>
                  { `${customer.company}` }
                  <br />
                  { `${customer.firstName} ${customer.lastName}.` }
                  <br />
                </>
              ) }

              { `${customer.email} ${
                customer.phone && customer.phone.trim().length > 3
                  ? `/ ${customer.phone}`
                  : ''
                }` }
            </SummaryItem>
          </Col>

          <Col verticalGutter mobile={ 12 } tablet={ 6 } desktop={ 6 }>
            <Box tertiary size="xxs">
              <PriceBoxItem
                leftText={ t('summary.price') }
                rightText={ numeral(obtainedPrice.price).format('$ 0,0.00') }
              />
              <PriceBoxItem
                leftText={ t('summary.taxes') }
                rightText={ numeral(obtainedPrice.taxes).format('$ 0,0.00') }
              />
              <PriceBoxItem
                bold
                leftText={ 'TOTAL' }
                rightText={ numeral(
                  obtainedPrice.price + obtainedPrice.taxes,
                ).format('$ 0,0.00') }
              />
            </Box>

            <Row marginTop="xxxs">
              <Col>
                <Text as="div" size="s" color="black">
                  { t('summary.offerValidity') }
                  <Text as="span" size="sBold" color="black">
                    { dayjs(document.pricingDate)
                      .add(3, 'month')
                      .format('DD.MM.YYYY') }
                  </Text>
                </Text>
              </Col>
            </Row>
          </Col>
        </Row>

        <Block flex responsive style={ { width: '100%' } }>
          <Block
            grow={ 1 }
            marginRightTablet="xxs"
            marginRightDesktop="xxs"
            marginBottom="xxs"
            marginBottomTablet="none"
            marginBottomDesktop="none"
          >
            <Button primary onClick={ this.presenter.onContract }>
              { t('buttons.contract') }
            </Button>
          </Block>
          { AgentService.isAgentOrBroker() ? (
            <>
              <Block
                grow={ 1 }
                marginRightTablet="xxs"
                marginRightDesktop="xxs"
                marginBottom="xxs"
                marginBottomTablet="none"
                marginBottomDesktop="none"
              >
                <Button grey onClick={ this.presenter.onBackToPortal }>
                  { t('buttons.saveOffer') /* t('buttons.backPortal') */ }
                </Button>
              </Block>
              <Block grow={ 1 } flex alignCenter>
                <div
                  style={ { cursor: 'pointer', display: 'inline-flex' } }
                  onClick={ () => this.presenter.onDownloadOfferPDF() }
                >
                  <ClickableIcon
                    src={ PdfSVG }
                    onClick={ this.presenter.onDownloadOfferPDF }
                  />
                  <Text as="span" color="primary">
                    { t('buttons.download') }
                  </Text>
                </div>
              </Block>
            </>
          ) : (
              <>
                <Block
                  grow={ 1 }
                  marginRightTablet="xxs"
                  marginRightDesktop="xxs"
                  marginBottom="xxs"
                  marginBottomTablet="none"
                  marginBottomDesktop="none"
                >
                  <Button grey onClick={ this.presenter.onSaveAndRetreiveLater }>
                    { t('buttons.saveOffer') }
                  </Button>
                </Block>
              </>
            ) }
        </Block>

        { !AgentService.isAgentOrBroker() && (
          <Block
            flex
            marginTopTablet="xxs"
            marginTopDesktop="xxs"
            marginTop="xxxs"
          >
            <Text as="p" size="xxs" color="black">
              { t('summary.retrieve') }
            </Text>
          </Block>
        ) }

        <Row verticalGutter marginTop="s">
          <Col>
            <ContactBox isCalledFrom="/summary" />
          </Col>
        </Row>
      </PageWrapper>
    )
  }
}

export const SummaryView = withNamespaces()(withRouter(SummaryRaw))
